import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const iyaiya: BlogMetaData = {
  title: 'イヤイヤ期の対応・接し方｜逆効果な関わりと声かけ6つのポイント',
  description:
    'イヤイヤ期の対応に悩む保護者へ。癇癪・言うことを聞かない場面で逆効果になりやすい接し方と、子どもが落ち着く声かけ6つのポイントを解説します。',
  thumbnailUrl: '/img/blog-iyaiya-thumbnail.webp',
  filePath: buildBlogFilePath('iyaiya'),
  category: BLOG_CATEGORY.PARENTING,
};
